import { useState, useEffect } from "react";
import aboutus from "@/public/images/aboutus.jpg";
import Image from "next/image";
import PaidConsultation from "@/components/shared/ReservationSection/components/Paid Consultation/PaidConsultation";
import { useTranslate } from "@/components/base/providers/TranslateProv";
import { Badge } from "@/components/ui/badge";
import logo from "@/public/Favicon.svg";

type Props = {};

export default function PopupMeassge({}: Props) {
  const [showMessage, setShowMessage] = useState(true);
  const { locale } = useTranslate();

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (showMessage) {
      timer = setTimeout(() => {
        setShowMessage(false);
      }, 20000);
    } else {
      timer = setTimeout(() => {
        setShowMessage(true);
      }, 60000);
    }

    return () => clearTimeout(timer);
  }, [showMessage]);

  const handleMessageClick = () => {
    setShowMessage(false);
  };

  return (
    <div
      className={`fixed z-[10] top-[75%] md:top-[85%] ${
        locale === "en" ? "right-[2%]" : "left-[2%]"
      }`}
      dir={locale === "en" ? "rtl" : "ltr"}
    >
      <div className="relative z-[101]">
        <PaidConsultation>
          <div className="relative inline-block z-50">
            <Image
              src={aboutus}
              alt="About Us"
              className="w-[75px] h-[75px] rounded-full object-cover shadow-xl border-[3px] border-[#1F0570]"
            />
            <div className="absolute -top-1 -right-2 bg-white rounded-full p-[3px] shadow-md flex items-center justify-center">
              <Image src={logo} alt="logo" className="w-8 h-8 object-contain" />
            </div>
          </div>
        </PaidConsultation>

        {showMessage && (
          <div
            className={`bg-[#1F0570] w-[220px] absolute p-[10px] rounded-[10px] -top-20 left-0 cursor-pointer
              
              ${
                locale === "ar"
                  ? "-top-20 left-0 text-start"
                  : "-top-32 right-0 text-end"
              }
              `}
            onClick={handleMessageClick}
          >
            <div className="grow shrink basis-0 text-sm w-fit  text-white font-normal font-['Somar Sans']">
              {locale === "ar"
                ? "تواصل مع سفير الجامعة لطلب استشارة ومساعدتك في التقديم والإجابة على جميع أسئلتك."
                : "Contact the university ambassador for consultation and assistance in applying and answering all your questions."}
            </div>
            <div
              className={`w-[10px] h-[10px] absolute -bottom-1 ${
                locale === "en" ? "right-3" : "left-3"
              } rotate-45 bg-[#1F0570]`}
            />
            <div
              className={`bg-[#ec4d4d] w-[14px] h-[14px] rounded-full absolute -top-[4px] shadow-lg shadow-[#e77979] ${
                locale === "en" ? "-left-[4px]" : " -right-[4px]"
              }`}
            />
          </div>
        )}
      </div>
    </div>
  );
}
